import { Sale } from "@towersystems/roam-common/lib/generated-types";
import { moneyToFormattedString } from "../../../../utilities/money";
import { Text, FlatActionList } from "@towersystems/roam-common-native";
import { bankersRound } from "@towersystems/roam-common/lib/shared-utils";

export interface SaleTotalsSummaryProps {
  sale: Sale;
}

export const SaleTotalsSummary = ({ sale }: SaleTotalsSummaryProps) => {
  return (
    <FlatActionList
      items={[
        {
          key: "discount",
          title: "Discount",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(sale.totalAdjustments)}
            </Text>
          ),
        },
        {
          key: "tax",
          title: "Tax",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(sale.totalTax)}
            </Text>
          ),
        },
        {
          key: "total",
          title: "Total",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(bankersRound(sale.totalPrice))}
            </Text>
          ),
        },
      ]}
    />
  );
};
